export const entries = Object.entries as <T>(o: T) => {
	[K in keyof T as 0]: [K, T[K]];
}[0][];
